export default __webpack_public_path__ + "374e6509cd49c5198f23a2afaeb627f3.svg";